<template>
    <button
        type="button"
        class="crm-card"
        :class="{ active }"
        @click="$emit('select')"
    >
        <span
            v-if="tag"
            class="crm-tag"
            :class="tagClass"
        >{{ tag }}</span>
        <span class="crm-logo">Другое</span>
    </button>
</template>

<script>
import { computed } from 'vue'

export default {
    name: 'OtherConnectorCard',
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        tag: {
            type: String,
            default: 'API',
        },
    },
    setup(props) {
        const tagClass = computed(() => {
            if (props.tag === 'API') return 'api'
            if (props.tag === 'Маркет') return 'auto'
            return ''
        })
        return { tagClass }
    },
}
</script>

<style lang="sass" scoped>
@import '@/vars.sass'

.crm-card
    height: 108px
    border: 1.5px solid #DDE3EF
    background: #fff
    border-radius: 16px
    padding: 14px
    display: flex
    align-items: center
    justify-content: center
    position: relative
    transition: 0.18s ease
    cursor: pointer
    user-select: none
    width: 100%
    min-width: 0
    overflow: hidden
    box-sizing: border-box
    font: inherit
    appearance: none
    outline: none
    &:hover
        border-color: rgba(82, 90, 213, 0.55)
        box-shadow: 0 10px 28px rgba(82, 90, 213, 0.10)
        transform: translateY(-1px)
    &.active
        border-color: $main-new
        box-shadow: 0 0 0 4px rgba(82, 90, 213, 0.10), 0 16px 34px rgba(82, 90, 213, 0.16)

.crm-tag
    position: absolute
    top: 10px
    right: 10px
    font-size: 9px
    font-weight: 900
    text-transform: uppercase
    letter-spacing: 0.06em
    border-radius: 999px
    padding: 4px 7px
    background: #F2F4F8
    color: $muted-new
    line-height: 1
    &.api
        background: $bcg-card-new
        color: $main-new
    &.auto
        background: #E9FFF4
        color: #12945D

.crm-logo
    font-weight: 900
    letter-spacing: -0.04em
    font-size: 19px
    line-height: 1
    color: $dark-new
    text-align: center

@media (max-width: 700px)
    .crm-card
        height: 94px
</style>
